// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatPanel-modulebody__DS8fP";
var _2 = "GretaAIChatPanel-modulecompact__bZXQC";
var _3 = "GretaAIChatPanel-moduleexpanded__OwQMt";
var _4 = "GretaAIChatPanel-modulemain__hXWsV";
var _5 = "GretaAIChatPanel-moduleminimized__RBgXl";
var _6 = "GretaAIChatPanel-modulemodeTransition__YkFpo";
var _7 = "GretaAIChatPanel-modulepanel__Io1KC";
var _8 = "GretaAIChatPanel-modulestrip__vKuhl";
export { _1 as "body", _2 as "compact", _3 as "expanded", _4 as "main", _5 as "minimized", _6 as "modeTransition", _7 as "panel", _8 as "strip" }
